import React from 'react';
import { Card } from '@iwoca/orion';
import clsx from 'clsx';
import { useReviewOffer } from 'components/ReviewOffer/ReviewOffer.context';
import { getApplicationTableData } from './SummaryCard.helpers';
import styles from './SummaryCard.module.css';
import { SummaryCardColumn } from './SummaryCardColumn/SummaryCardColumn';
import { SummaryCardLabels } from './SummaryCardLabels/SummaryCardLabels';

export const SummaryCard = () => {
  const { selectedApplication: application, hasInterestOnlyOffer } =
    useReviewOffer();
  const { columns, fields } = getApplicationTableData(application);

  return (
    <Card
      className={clsx(styles.summaryCard, styles[application.status], {
        [styles.hasInterestOnlyOffer]: hasInterestOnlyOffer,
      })}
      data-testid="summary-card"
    >
      <SummaryCardLabels fields={fields} />
      <div className={styles.summaryCardColumns}>
        {columns.map((offer, i) => {
          return (
            <SummaryCardColumn
              key={`${offer.product_type}-${i}`}
              fields={fields}
              hasAction={
                application.status === 'offered' ||
                application.status === 'conditional_offer'
              }
              offer={offer as any}
              applicationId={application.application_uid}
            />
          );
        })}
      </div>
    </Card>
  );
};
